// import "./todosError.css"
function TodosError() {
    return (
        <p>Error...</p>
    )
}
export { TodosError }